import initialState from '../store/initial-state'
import {
  GROUP_BY_CLIENT,
  GROUP_BY_CLIENT_SUCCESS,
  GROUP_BY_CLIENT_FAILURE,
  GROUP_BY_CLIENT_USER_ID,
  GROUP_BY_CLIENT_USER_ID_SUCCESS,
  GROUP_BY_CLIENT_USER_ID_FAILURE,
  GROUP_DETAIL,
  GROUP_DETAIL_SUCCESS,
  GROUP_DETAIL_FAILURE,
  GROUP_CREATE,
  GROUP_CREATE_SUCCESS,
  GROUP_CREATE_FAILURE,
  GROUP_DELETE,
  GROUP_DELETE_SUCCESS,
  GROUP_DELETE_FAILURE,
  GROUP_UPDATE,
  GROUP_UPDATE_SUCCESS,
  GROUP_UPDATE_FAILURE,
  GROUP_EMPTY,
  GROUP_APPROVED_REJECTED,
  GROUP_APPROVED_REJECTED_SUCCESS,
  GROUP_APPROVED_REJECTED_FAILURE,
  EDIT_ADMIN_GROUP,
  GET_DEFAULT_PERMISSIONS,
  GET_DEFAULT_PERMISSIONS_FAILURE,
  GET_DEFAULT_PERMISSIONS_SUCCESS
} from '../constants/group-types'

export default (state = initialState.group, action) => {
  switch (action.type) {

    case GROUP_BY_CLIENT:
      return {
        ...state,
        byClientIsFetching: true,
        byClientData: [],
        byClientStatus: ''
      }

    case GROUP_BY_CLIENT_SUCCESS:
      return {
        ...state,
        byClientIsFetching: false,
        byClientData: action.payload,
        byClientStatus: 'success'
      }

    case GROUP_BY_CLIENT_FAILURE:
      return {
        ...state,
        byClientIsFetching: false,
        byClientData: action.payload,
        byClientStatus: 'failure'
      }

    case GROUP_BY_CLIENT_USER_ID:
      return {
        ...state,
        isFetching: true,
        byClientUserData: [],
        matrix: [],
        newMatrix: [],
        status: ''
      }

    case GROUP_BY_CLIENT_USER_ID_SUCCESS:
      return {
        ...state,
        isFetching: false,
        byClientUserData: action.payload.data,
        newMatrix: action.payload.data.map(r => {
          return {
            _id: r._id,
            objects: r.objects,
            permissions: r.permissions
          }
        }),
        full: action.payload.permissionDefault.map(def => {
          const exists = action.payload.data.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
          return {
            action: def.action,
            enabled: exists ? true : false
          }
        }),
        matrix: action.payload.permissionDefault.map(def => {
          const exists = action.payload.data.find(r => r.permissions.find(item => item.action === def.action && item.enabled === true))
          return {
            action: def.action,
            enabled: exists ? true : false
          }
        }),
        status: 'success'
      }

    case GROUP_BY_CLIENT_USER_ID_FAILURE:
      return {
        ...state,
        isFetching: false,
        byClientUserData: [],
        status: 'failure'
      }

    case GROUP_CREATE:
      return {
        ...state,
        isCreating: true,
        createStatus: ''
      }

    case GROUP_CREATE_SUCCESS: {
      return {
        ...state,
        isCreating: false,
        createStatus: 'success',
      }
    }

    case GROUP_CREATE_FAILURE: {
      return {
        ...state,
        isCreating: false,
        createStatus: 'failure'
      }
    }

    case GROUP_DETAIL: {
      return {
        ...state,
        detailIsFetching: true,
        detail: null,
        detailStatus: ''
      }
    }

    case GROUP_DETAIL_SUCCESS: {
      return {
        ...state,
        detailIsFetching: false,
        detail: action.payload,
        detailStatus: 'success'
      }
    }

    case GROUP_DETAIL_FAILURE: {
      return {
        ...state,
        detailIsFetching: false,
        detail: null,
        detailStatus: 'failure'
      }
    }

    case GROUP_DELETE: {
      return {
        ...state,
        deleteIsFetching: true,
        deleteStatus: ''
      }
    }

    case GROUP_DELETE_SUCCESS: {
      return {
        ...state,
        deleteIsFetching: false,
        deleteStatus: 'success'
      }
    }

    case GROUP_DELETE_FAILURE: {
      return {
        ...state,
        deleteIsFetching: false,
        deleteStatus: 'failure'
      }
    }

    case GROUP_UPDATE: {
      return {
        ...state,
        updateIsFetching: true,
        updateStatus: '',
        status: ''
      }
    }
    case GROUP_UPDATE_SUCCESS: {
      return {
        ...state,
        updateIsFetching: false,
        updateStatus: 'success',
        status: action.payload.data
      }
    }
    case GROUP_UPDATE_FAILURE: {
      return {
        ...state,
        updateIsFetching: false,
        updateStatus: 'failure',
      }
    }

    case GROUP_EMPTY: {
      return {
        ...state,
        byClientData: [],
        byClientStatus: '',
        updateStatus: '',
        deleteStatus: '',
        detail: null,
        byClientUserData: [],
        matrix: [],
        status: ''
      }
    }

    case GROUP_APPROVED_REJECTED: {
      return {
        ...state,
        aprovvedRejectedIsFetching: true
      }
    }

    case GROUP_APPROVED_REJECTED_SUCCESS: {
      return {
        ...state,
        aprovvedRejectedIsFetching: false
      }
    }

    case GROUP_APPROVED_REJECTED_FAILURE: {
      return {
        ...state,
        aprovvedRejectedIsFetching: false
      }
    }

    case EDIT_ADMIN_GROUP: {
      return {
        ...state,
        hideButton: action.payload
      }
    }

    case GET_DEFAULT_PERMISSIONS: {
      return {
        ...state,
        isFetchingDefaultPermissions: true
      }

    }

    case GET_DEFAULT_PERMISSIONS_SUCCESS: {
      return {
        ...state,
        isFetchingDefaultPermissions: false,
        defaultPermissions: action.payload
      }
    }

    case GET_DEFAULT_PERMISSIONS_FAILURE: {
      return {
        ...state,
        isFetchingDefaultPermissions: false,
        defaultPermissions: []
      }
    }


    default: return { ...state }
  }
}